<template>
    <div>
        <div class="modal-overlay active" @click="closeDialog()"></div>
        <div class="modal suggested-address-modal">
            <div class="modal__header">
                <h2 class="headline-s">Delete Payment Method?</h2>
                <CloseIcon @click="closeDialog()" class="modal__header--close" alt="Close Modal" aria-label="Close" />
            </div>
            <div class="actions">
                <RothcoCta class="primary" id="submitButton" @click="submit()">Yes</RothcoCta>
            </div>
        </div>
    </div>
</template>
<script lang="ts" setup>
    import { computed, inject } from "vue";
    import RothcoCta from "@/components/RothcoCta.vue";
    import CloseIcon from "@icons/closeIcon.svg";
    const dialogRef = inject('dialogRef');
    const closeDialog = () => {
        dialogRef?.value?.close();
    };
    const paymentMethodId = computed(()=>{
        return dialogRef.value?.data?.credit_card_id;
    });
    const submit = ()=>{
        dialogRef?.value?.data?.deletePaymentMethod(paymentMethodId.value);
        closeDialog();
    };
</script>